import WordList from "./WordList";
import "./WordBin.css";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/esm/Button";

function WordBin(props) {
  const restartGame = () => {
    window.location.reload();
  };
  return (
    <Col>
      <Row>{props.words.length > 0 ? <h1>Word Bin</h1> : ""}</Row>
      {props.words.length > 0 ? (
        props.words.map((word) => (
          <WordList
            key={word.id}
            id={word.id}
            name={word.word}
            margin={"0.25rem"}
            dragType={"word"}
          />
        ))
      ) : (
        <>
          <h2 style={{ marginTop: "25px" }}>
            Congratulations you have correctly dragged all the words to their
            image!
          </h2>
          <h5>
            To play again press the Restart Game button below. You can also
            select the Back to game select in the top left corner.
          </h5>
          <Button onClick={restartGame}>Restart Game</Button>
        </>
      )}
    </Col>
  );
}
export default WordBin;
